<template>
  <div>
    <div class="text-left mb-5">
      <span class="headline" id="headerlist">User List</span>
    </div>
    <!-- Table Start -->
    <div class="holder">
      <div class="filter">
        <v-text-field
          v-model="filter"
          v-on:keyup="filterList"
          label="search by user name"
          append-icon="mdi-filter"
        />
      </div>
      <div class="paginate">
        <v-select
          v-model="paginationcount"
          v-on:change="paginateList"
          :items="paginationcounts"
          item-text="name"
          item-value="name"
          :selected="paginationcounts.value === 10"
          label="show by"
        ></v-select>
      </div>
    </div>
    <v-simple-table fixed-header fixed-footer height="450px" class="elevation-2">
      <template v-slot:default>
        <thead>
          <tr class="tableheader">
            <th class="text-left">Name</th>
            <th class="text-left">Email Address</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in users" :key="item.id" @click="showUser(item.id)">
            <td class="text-left">{{ item.name }}</td>
            <td class="text-left">{{ item.email }}</td>
          </tr>
          <tr v-if="pagination.meta.total == 0">
            <td colspan="3" style="height:400px; text-align: center;">
              No records found
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div class="pt-2">
      <v-pagination
        v-if="pagination.meta.total > 0"
        align="right"
        v-model="page"
        :length="pagination.meta.last_page"
        circle
      ></v-pagination>
    </div>
    <!-- Table End -->
    <!-- Create Start -->
    <v-btn fixed bottom right @click="$router.push('/user/create')" color="blue darken-2" dark fab>
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <userCreate
      v-if="create"
      :page="page"
      :create="create"
      @createChange="
        value => {
          this.create = value;
        }
      "
    />
    <userEdit v-if="edit" :page="page" :edit="edit" />
    <userShow v-if="show" :show="show" :page="page" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';
import userCreate from './UserCreate';
import userEdit from './UserEdit';
import userShow from './UserShow';

export default {
  data: function() {
    return {
      page: 1,
      filter: '',
      paginationcount: '10'
    };
  },
  components: {
    userCreate,
    userEdit,
    userShow
  },
  props: {
    create: false,
    show: false,
    edit: false
  },
  watch: {
    page(val) {
      this['User/fetchUsers']({
        page: val,
        filter: this.filter,
        paginationcount: this.paginationcount
      });
    },
    $route(to, from) {
      if (this.show) {
        this['User/getUser']({ id: to.params.id });
      }
    }
  },
  computed: {
    ...mapState({
      users: state => state.User.users.data,
      paginationcounts: state => state.Unit.paginationcount,
      pagination: state => {
        if (state.User.users.length === 0) {
          return {
            meta: {
              last_page: 0
            }
          };
        }
        return state.User.users;
      }
    })
  },
  mounted() {
    this['User/fetchUsers']({ page: this.page, paginationcount: this.paginationcount });
  },
  methods: {
    ...mapActions(['User/fetchUsers', 'User/getUser']),
    showUser(id) {
      this.$router.push(`/user/${id}`);
    },
    filterList() {
      if (this.page !== 1) this.page = 1;
      else
        this['User/fetchUsers']({
          page: this.page,
          filter: this.filter,
          paginationcount: this.paginationcount
        });
    },
    paginateList() {
      if (this.page !== 1) this.page = 1;
      else this['User/fetchUsers']({ page: 1, paginationcount: this.paginationcount });
    }
  }
};
</script>
